<form
  name="userProfileForm"
  (ngSubmit)="formSubmit()"
  [formGroup]="userProfileForm"
  novalidate
>
  <div class="user-profile">
    <div
      class="container p-0"
      [ngClass]="{ 'content-loading-disabled': isLoader }"
    >
      <!--<div class="loading-spinner-overlay" *ngIf="isLoader">
        <i class="fa fa-spinner fa-spin"></i>
      </div>-->
      <div class="bg-white p-4 mt-2">
        <div class="row">
          <div class="col-md-6">
            <!--<h4>
              Profile <i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i>
            </h4>-->

            <div class="row">
              <div class="col-md-6 hidden-sm">
                <div class="form-group row mt-3">
                  <label class="col-form-label" for="userName">Username</label>
                  <div class="col-sm-12">
                    <input type="text"
                           class="form-control"
                           formControlName="userName"
                           id="userName"
                           disabled
                           data-lpignore="true" />
                  </div>
                </div>
              </div>


              <div class="col-md-6 show-sm">
                <div class="form-group row mt-3">
                  <label class="col-form-label" for="userName">Username</label>
                  <div class="col-sm-12">
                    <input type="text"
                           class="form-control"
                           formControlName="userName"
                           id="userName"
                           disabled
                           data-lpignore="true" />
                  </div>
                </div>


              </div>
            </div>
          </div>
          <div class="col-md-6 text-end">
            <div class="avatar-upload mobile-mt-20">
              <div class="avatar-edit">
                <input type="file"
                       id="imageUpload"
                       accept=".png, .jpg, .jpeg"
                       #fileInput
                       (change)="uploadFile($event)" />
              </div>
              <div class="avatar-preview">
                <img id="imagePreview" [src]="imageUrl" />
              </div>
              <div class="closeBtn">
                <label class="fa fa-camera btn-img"
                       (click)="fileInput.click()"
                       role="button"></label>
              </div>
            </div>
          </div>
        </div>

        <hr style="margin-top:20px !important" />
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-2">
                <label class="col-form-label" for="title">Title</label>

                <select class="form-select"
                        formControlName="title">
                  <option value=""></option>
                  <option value="Dr">Dr</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Miss">Miss</option>
                  <option value="Master">Master</option>
                  <option value="Madam">Madam</option>
                </select>


              </div>

              <div class="col-md-4">
                <label class="col-form-label" for="firstName">First Name</label>

                <input type="text"
                       id="firstName"
                       class="form-control"
                       formControlName="firstName"
                       [ngClass]="{
                    'border border-danger ':
                      submitted &&
                      userProfileForm.hasError('required', 'firstName')
                  }" />

                <span class="text-danger"
                      *ngIf="
                    submitted &&
                    userProfileForm.hasError('required', 'firstName')
                  ">
                  First Name is required!
                </span>
              </div>

              <div class="col-md-4">
                <label class="col-form-label" for="lastName">Last Name</label>

                <input type="text"
                       id="lastName"
                       formControlName="lastName"
                       class="form-control"
                       [ngClass]="{
                    'border border-danger ':
                      submitted &&
                      userProfileForm.hasError('required', 'lastName')
                  }" />
                <span class="text-danger"
                      *ngIf="
                    submitted &&
                    userProfileForm.hasError('required', 'lastName')
                  ">
                  Last Name is required!
                </span>
              </div>

              <div class="col-md-2">
                <label class="col-form-label" for="suffix">Suffix</label>

                <input type="text"
                       class="form-control"
                       id="suffix"
                       formControlName="suffix" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="col-form-label" for="degree">Degree</label>

                <input type="text"
                       class="form-control"
                       id="degree"
                       formControlName="degree" />
              </div>
              <div class="col-md-6">
                <label class="col-form-label" for="accreditation">Accreditation</label>

                <input type="text"
                       class="form-control"
                       formControlName="accreditation"
                       [ngClass]="{
                    'border border-danger ':
                      submitted &&
                      userProfileForm.hasError('required', 'accreditation')
                  }" />
                <span class="text-danger"
                      *ngIf="
                    submitted &&
                    userProfileForm.hasError('required', 'accreditation')
                  ">
                  Acreditation are required!
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="col-form-label" for="replyToEmailAddress">Reply To Email</label>

                <input type="email"
                       class="form-control"
                       id="replyToEmailAddress"
                       formControlName="replyToEmailAddress" />
              </div>
              <div class="col-md-6">
                
              </div>
            </div>

            <hr />
            <div class="row">
              <div class="col-12">
                <div class="form-group row mt-3">
                  <label for="trackingURL">Email Signature</label>
                  <div class="col-sm-12">
                    <div [ngxSummernote]="config" formControlName="emailSignature"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="!isLoader && isUseBuiltInSave">
          <div class="col-12 text-end pt-3">
            <button
              type="button"
              class="btn btn-secondary me-2"
              routerLink="/sales"
            >
              <i class="fa fa-times"></i> Cancel
            </button>
            <button type="submit" class="btn btn-primary btn-primary-color">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
